/** Approved opening paragraph — Mentology Classroom landing. */

export const LANDING_OPENING_PARAGRAPH =
  'Welcome to Mentology Classroom—a dedicated study and application environment '
  + 'for structured learning and behavioural transformation. This space is designed not '
  + 'as a conventional business training course, but as an analytical laboratory where '
  + 'you step away from the traditional Expert Trap, closing the gap between intention '
  + 'and practice through the depth of the Socratic method. Through disciplined reflection, '
  + 'structural inquiry, and double-loop learning, the curriculum moves you away from '
  + "fixing immediate problems toward a lifelong foundation for transformational understanding.";
